if( ! document.getElementById("employee-profile-detail") ) {
    return;
}


/* auto complete for the preferred location */
document.addEventListener('DOMContentLoaded', function () {
    const input = document.getElementById('preferred-location');
    if (!input) return;

    let selectedPlace = null;
    let placeSelected = false;

    const autocomplete = new google.maps.places.Autocomplete(input, {
        types: ['(regions)'],
        componentRestrictions: { country: ['AU', 'NZ'] }
    });

    // User starts typing again → invalidate previous selection
    input.addEventListener('input', function () {
        placeSelected = false;
        selectedPlace = null;
    });

    autocomplete.addListener('place_changed', function () {
        const place = autocomplete.getPlace();

        // Ensure a real autocomplete selection happened
        if (!place || !place.place_id) {
            placeSelected = false;
            selectedPlace = null;
            return;
        }

        placeSelected = true;
        selectedPlace = place.formatted_address || input.value;

        input.value = selectedPlace;
    });

    function validateLocation() {
        const typedValue = input.value.trim();

        // Allow empty
        if (typedValue === '') {
            selectedPlace = null;
            placeSelected = false;
            return true;
        }

        // Reject manual text
        if (!placeSelected) {
            input.value = '';
            employerCreateJobModal('Please select a valid region from the list.');
            input.focus();
            return false;
        }

        return true;
    }

    // Blur validation
    input.addEventListener('blur', function () {
        // Longer delay helps Edge/mobile browsers
        setTimeout(validateLocation, 500);
    });

    // Form submit validation
    const form = input.closest('form');

    if (form) {
        form.addEventListener('submit', function (e) {
            if (!validateLocation()) {
                e.preventDefault();
            }
        });
    }
});

const modalElement = document.querySelector('.custom-message-modal-overlay');
const confirmUpdate = document.querySelector('.custom-message-modal-btn.confirm');
const confirmBtnCancel = document.querySelector('.custom-message-modal-btn.btn-delete.cancel');
confirmUpdate.style.display = 'none';
confirmBtnCancel.style.display = 'none';

// const modal = document.querySelector('.custom-message-modal-overlay');
// if (modal) {
//     modal.addEventListener('click', function(e) { 
//         if (e.target.classList.contains('updated') || e.target.classList.contains('account-detail')) {
//             modal.classList.remove('d-flex');
//             e.target.remove();
//         }
//     });
// }

function employeeProfileDetailModal(message, title='Attention Required') {
    const modalTitle = document.querySelector('.custom-message-modal-title');
    const modalFooter = document.querySelector('.custom-message-modal-footer');
    const confirmButton = document.createElement('button');
    confirmButton.className = 'custom-message-modal-btn btn btn-primary btn-xs account-detail';
    confirmButton.textContent = 'Ok';

    if( modalElement ) modalElement.classList.add('processing');
    const modalCross = document.querySelector('.custom-message-modal-close');
    if( modalCross ) modalCross.style.display = 'none';

    if (modalTitle) modalTitle.innerHTML = title;
    if (modalFooter) {
        modalFooter.appendChild(confirmButton);
    }

    const modalMessage = document.querySelector('.custom-message-modal-body p');
    if (modalMessage) {
        modalMessage.innerHTML = message;
    }

    const modalTriggerBtn = document.querySelector('.open-modal-btn');
    if (modalTriggerBtn) {
        modalTriggerBtn.click();
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const benefitCheckboxes = document.querySelectorAll('.working-environment input[type="checkbox"]');
    if( benefitCheckboxes ) {
        let selected = [];
        benefitCheckboxes.forEach(benefit => {
            benefit.addEventListener('change', () => { 
                if (benefit.checked) {
                    selected.push(benefit);
                    if (selected.length > 3) {
                        const first = selected.shift();
                        first.checked = false;
                    }
                } else {
                    selected = selected.filter(item => item !== benefit);
                }
            });
        });
    }
});

document.getElementById('about-user').addEventListener('input', function(e) {
    // Allowed characters: letters, numbers, punctuation, spaces, and newlines
    const allowedCharsRegex = /[^\p{L}\p{N}\p{P}\p{Zs}\r\n]/gu;

    // Get the original value
    const originalValue = this.value;

    // Remove disallowed characters
    const cleanedValue = originalValue.replace(allowedCharsRegex, '');

    // If anything was removed, update the textarea
    if (originalValue !== cleanedValue) {
        this.value = cleanedValue;
    }
    console.log(this.value);
});


const employeeProfileDetail = document.getElementById("employee-profile-detail");
employeeProfileDetail.addEventListener("submit", function(event) {
    event.preventDefault();
    
    if(document.querySelector('.custom-message-modal-btn.updated')) {
        document.querySelector('.custom-message-modal-btn.updated').remove();
    }
    
    const aboutUser = document.getElementById("about-user").value;
    const name = document.getElementById("name").value.trim();
    const professionalTitle = document.getElementById("professional-title").value.trim();
    const industrySector = document.getElementById("industry-sector").value.trim();

    const minSalary = document.getElementById('min-salary').value; 
    const maxSalary = document.getElementById('max-salary').value; 

    // const licenseName = document.getElementById('license-name').value.trim();
    // const licenseNumber = document.getElementById('license-number').value.trim();
    // const licenseState = document.getElementById('license-state').value.trim();
    // const licenseExpiry = document.getElementById('expiryDate').value;
    
    const resumeFileInput = document.getElementById("upload-resume");
    const cvFileInput = document.getElementById("cover-letter");
    const maxSize = 5 * 1024 * 1024; // 5MB in bytes
    const resumeUploaded = resumeFileInput.getAttribute('data-resume');
    const cvUploaded = cvFileInput.getAttribute('data-cv');

    const uploadedResume = document.getElementById("uploaded-resume").value;
    const uploadedCV = document.getElementById("uploaded-cv").value;
    
   //  const licenseFieldsFilled = licenseName || licenseNumber || licenseState || licenseExpiry;
    // const benefitsChecked = document.querySelectorAll('.working-environment input[type="checkbox"]:checked').length;

    // const clinicalRole = document.getElementById('profile-detail-jobcategory').value;
    // const jobCategory = document.getElementById(`job-category-${clinicalRole}`).value.trim();

    const agreeCheckbox = document.getElementById('terms-and-conditions');

    const errors = [];

    if (aboutUser.trim() === '') {
        // optional required validation
    } else {
        if (aboutUser.length < 2 || aboutUser.length > 500) {
            errors.push({
                message: 'About must be between 2 and 500 characters',
                scrollDiv: '.site-main--contents',
                attrId: 'about-user'
            });
        }
    }
    if (name === '') {
        errors.push({ message: 'Name is required', scrollDiv: '#about-user', attrId: 'name' });
    } else {
        const nameRegex = /^[a-zA-Z\s&._-]{2,50}$/;
        if (!nameRegex.test(name)) {
            errors.push({ message: 'Employer name must be alphabets of 2-50 characters including "&, ., _ and -"', scrollDiv: '.pages-employer-profile_detail', attrId: 'employer-name' });
        }
    }
    if (professionalTitle === '') {
        // errors.push({ message: 'Professional title is required', scrollDiv: '#about-user', attrId: 'professional-title' });
    }
    if (industrySector === '') {
        // errors.push({ message: 'Please select industry sector', scrollDiv: '#name', attrId: 'industry-sector' });
    }
    // -- resume upload -- //
    if ((resumeFileInput.files.length === 0) && (resumeUploaded === '')) {
        // errors.push({ message: 'Please upload resume', scrollDiv: '#professional-title', attrId: 'field-resume' });
    }
    if ((resumeFileInput.files.length != 0) && (resumeUploaded != '')) {
        const resumeFile = resumeFileInput.files[0];
        if (resumeFile) {
            if (resumeFile.size > maxSize) {
                errors.push({ message: 'File size exceeds 5MB. Please upload a smaller file.', scrollDiv: '#professional-title', attrId: 'field-resume' });
            }
        }
    }
    // --- resume upload --- //
    
    // -- cv upload -- //
    if ((cvFileInput.files.length === 0) && (cvUploaded === '')) {
        // errors.push({ message: 'Please upload coverletter', scrollDiv: '#professional-title', attrId: 'field-cv' });
    }
    if ((cvFileInput.files.length != 0) && (cvUploaded != '')) {
        const cvFile = cvFileInput.files[0];
        if (cvFile) {
            if (cvFile.size > maxSize) {
                errors.push({ message: 'File size exceeds 5MB. Please upload a smaller file.', scrollDiv: '#professional-title', attrId: 'field-cv' });
            }
        }
    }
    // --- cv upload --- //

    // -- min max salary validation --//
    const hasMin = minSalary !== '';
    const hasMax = maxSalary !== '';

    let minValid = false;

    if (hasMin) {
        if (isNaN(minSalary) || Number(minSalary) <= 0) {
            errors.push({ message: 'Minimum salary must be a number greater than 0', scrollDiv: '.working-pattern', attrId: 'min-salary' });
        } else {
            minValid = true;
        }
    } else if (hasMax) {
        errors.push({ message: 'Enter an expected minimum salary first', scrollDiv: '.working-pattern', attrId: 'min-salary' });
    }

    // Only validate max if min is valid
    if (minValid) {
        if (!hasMax) {
            errors.push({ message: 'Enter an expected maximum salary', scrollDiv: '.working-pattern', attrId: 'max-salary' });
        } else if (isNaN(maxSalary) || Number(maxSalary) <= 0) {
            errors.push({ message: 'Maximum salary must be a number greater than 0', scrollDiv: '.working-pattern', attrId: 'max-salary' });
        } else {
            const min = Number(minSalary);
            const max = Number(maxSalary);
            if (max < min) {
                errors.push({ message: 'Expected maximum salary must be greater than or equal to minimum salary', scrollDiv: '.working-pattern', attrId: 'max-salary' });
            }
            if (max > 9000000) {
                errors.push({ message: 'Expected maximum salary must not exceed 9,000,000', scrollDiv: '.working-pattern', attrId: 'max-salary' });
            }
        }
    }
    // --- min max salary validation ---//
    
    // if( benefitsChecked != 3 ) {
        // errors.push({ message: 'Select top 3 qualities you expect as candidate', scrollDiv: '#min-salary', attrId: 'field-working-environment' });
    // }

    // if (licenseFieldsFilled) {
    //     if (!licenseName) {
    //         // errors.push({ message: 'License name is required', scrollDiv: '#teamEnvironment', attrId: 'license-name' });
    //     }
    //     if (!licenseNumber) {
    //         // errors.push({ message: 'License number is required', scrollDiv: '#teamEnvironment', attrId: 'license-number' });
    //     } else {
    //         if (isNaN(licenseNumber)) {
    //             // errors.push({ message: 'License number must be a valid number.', scrollDiv: '#teamEnvironment', attrId: 'license-number' });
    //         }
    //     }
    //     if (!licenseState) {
    //         // errors.push({ message: 'License state is required', scrollDiv: '#teamEnvironment', attrId: 'license-state' });
    //     }
    //     if (!licenseExpiry) {
    //         // errors.push({ message: 'License expiry is required', scrollDiv: '#teamEnvironment', attrId: 'expiryDate' });
    //     }
    // }

    if (!agreeCheckbox.checked) {
        errors.push({ message: 'To continue, please indicate your agreement to the Terms and Conditions.', scrollDiv: '#ideal-role', attrId: 'field-terms-condition' });
    }

    const errorElements = document.querySelectorAll('.err');
    if(errorElements) errorElements.forEach(el => el.remove());

    if (errors.length > 0) {
        errors.forEach(error => {
            const errID = document.getElementById(error.attrId);
            const errMessage = error.message;
            if (errID) {
                const p = document.createElement('p');
                p.className = 'err';
                p.textContent = errMessage;

                if (error.attrId === 'contactNumber') {
                    const formElement = errID.closest('.form-element');
                    if (formElement) {
                        formElement.appendChild(p);
                    } else {
                        // fallback if .form-element not found
                        errID.after(p);
                    }
                } else {
                    errID.after(p);
                }
            }
        });

        // employeeProfileDetailModal('<p>Please fill in all necessary details to proceed.</p>');
        
        const target = document.querySelector(errors[0].scrollDiv);
        if (target) target.scrollIntoView({ behavior: 'smooth' });
        return;
    }

    // -- social links -- //
    const socialItems = document.querySelectorAll('.social-profile-item');
	const urlPattern = /^(https?:\/\/)?([\w\-]+\.)+[\w\-]+(\/[\w\-./?%&=]*)?$/i;
    const socialProfiles = [];
    let invalidUrl = false;
    socialItems.forEach(item => {
        const nameInput = item.querySelector('input[name="social-name[]"]');
        const urlInput = item.querySelector('input[name="social-url[]"]');

        const name = nameInput?.value.trim();
        const url = urlInput?.value.trim();

        if (!url || !urlPattern.test(url)) {
            invalidUrl = true; 
            urlInput.focus();
            return;
        }

        if (name && url) {
            socialProfiles.push({
                socialName: name,
                socialUrl: url
            });
        }
    });
    if( invalidUrl ) {
        employeeProfileDetailModal('<p>Valid url is required</p>');
        document.querySelector('#right-to-work').scrollIntoView({ behavior: 'smooth' });
        return;
    }
    if (socialProfiles.length === 0) {
        // employeeProfileDetailModal('<p>No social url data found.</p>');
        // const el = document.querySelector('.form-element-group.social-profile');
        // const p = document.createElement('p');
        // p.className = 'err';
        // p.textContent = 'No social url data found';
        // el.append(p);
        // const offset = 100;
        // const y = el.getBoundingClientRect().top + window.scrollY - offset;
        // window.scrollTo({ top: y, behavior: 'smooth' });
        // return;
    }
    // --- social links --- //

    // -- qualification -- //
    const qualificationEntries = document.querySelectorAll(".my-qualifications-item-wrap");
    let qualificationData = [];
    qualificationEntries.forEach(entry => {
        const name = entry.querySelector(".course-name").value.trim();
        const place = entry.querySelector(".course-place").value.trim();
        const year = entry.querySelector(".course-year").value.trim();
        
        qualificationData.push({
            qualificationName: name,
            placeOfCompletion: place,
            yearOfCompletion: year,
        });
    });
    if (qualificationData.length === 0) {
        // employeeProfileDetailModal('<p>No qualification data found.</p>');
        // const el = document.querySelector('.form-element-group.my-qualifications');
        // const p = document.createElement('p');
        // p.className = 'err';
        // p.textContent = 'No qualification data found';
        // el.append(p);
        // const offset = 100;
        // const y = el.getBoundingClientRect().top + window.scrollY - offset;
        // window.scrollTo({ top: y, behavior: 'smooth' });
        // return;
    }
    // --- qualification --- //

    // -- skills --//
    const skillElements = document.querySelectorAll('.skills-list-item input[type="text"]');
    let skillData = [];

    skillElements.forEach(el => {
        const skill = el.value.trim();
        if (skill) {
            skillData.push({ skill });
        }
    });
    if (skillData.length === 0) {
        // employeeProfileDetailModal('<p>No skills entered.</p>');
        // const el = document.querySelector('.form-element--skills');
        // const p = document.createElement('p');
        // p.className = 'err';
        // p.textContent = 'No skills data found';
        // el.append(p);
        // const offset = 100;
        // const y = el.getBoundingClientRect().top + window.scrollY - offset;
        // window.scrollTo({ top: y, behavior: 'smooth' });

        // return;
    }
    // --- skills --- //

    const formData = new FormData(employeeProfileDetail); 

    formData.append('action', 'employee_profile_detail');
    formData.append('nonce', ajax_callback_data.ajax_nonce);
    formData.append('social_profile', JSON.stringify(socialProfiles));
    formData.append('qualification', JSON.stringify(qualificationData));
    formData.append('license', JSON.stringify(qualificationData));
    formData.append('skills', JSON.stringify(skillData));

    employeeProfileDetailModal('<p>Applying account update...</p>', 'Please wait');
    document.querySelector('.custom-message-modal-footer').innerHTML = '';

	fetch(ajax_callback_data.ajax_url, {
        method: 'POST',
        body: formData,
    })
    .then(response => response.json())
    .then(data => {
        if( data.success ) {
            employeeProfileDetailModal(data.data.message, 'Confirmation');
            document.querySelector('.custom-message-modal-footer').innerHTML = '';
            document.querySelector('.site-main--contents').scrollIntoView({ behavior: 'smooth' });
            
            window.location.reload(); 

        } else {
            if( data.data?.message ) {
                employeeProfileDetailModal(data.data.message);
            } else {
                employeeProfileDetailModal('Something went wrong. Try again.');
            }
        }
    })
    .catch(error => {
        console.error('Error:', error);
        employeeProfileDetailModal('Something went wrong. Try again.');
    });
});